<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
  },
}
</script>
<!-- section template -->
<template>
  <div :class="[$style.baseSectionTitleSecondary, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
    <h3
      v-if="!!title"
      class="baseSectionTitleSecondary__title"
    >
      <span v-html="title"></span>
      <span v-if="!!tip">
        <el-popover
          placement="right"
          width="300"
          trigger="hover"
        >
          <BaseButton
            slot="reference"
            class="isStylePrimary isText ml-1"
          >
            <i class="fontello fontello-attention"></i>
          </BaseButton>
          <span v-html="tip"></span>
        </el-popover>
      </span>
    </h3>
    <p
      v-if="!!description || !!$slots['description']"
      class="baseSectionTitleSecondary__description"
    >
      <slot v-if="!!$slots['description']" name="description"/>
      <span v-else v-text="description"></span>
    </p>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.baseSectionTitleSecondary {
  margin-bottom: 1.5rem;

  :global {
    .baseSectionTitleSecondary {
      &__title {
        position: relative;
        padding-left: 1rem;
        margin-bottom: 1rem;
        font-size: 1.25rem;
        font-weight: 600;
        line-height: 1;
        color: $color-blue-dark;
        letter-spacing: 0.15em;

        &::before {
          position: absolute;
          top: 0;
          left: 0;
          width: 3px;
          height: 1em;
          content: '';
          background: $color-blue-dark;
          border-radius: 10px;
        }

        @include max-md {
          font-size: 1.125rem;
        }
      }

      &__description {
        margin-bottom: 0;
        font-size: 0.875rem;
        line-height: 1.75;
        color: $color-gray-2;
        white-space: pre-wrap;

        a {
          color: $color-gray-2;

          &:hover {
            color: $color-primary;
          }
        }
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .baseSectionTitleSecondary {
        &__title {
          color: $color-blue-dark;
          font-weight: 400;
          font-size: 1.125rem;
          letter-spacing: 0.12em;
          &::before {
            position: absolute;
            top: 0;
            left: 0;
            width: 3px;
            height: 1em;
            content: '';
            background: $color-primary;
            border-radius: 10px;
          }
        }
      }
    }
  }
}
</style>
